import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ImageCarouselModule } from '@app/shared/image-carousel/image-carousel.module';
import { DetailsAccordionModule } from '@app/shared/ux/accordion/details-accordion.module';
import { MyClaimsOverviewContentComponent } from './claims-overview-content.component';

@NgModule({
    imports: [CommonModule, DetailsAccordionModule, ImageCarouselModule, RouterModule],
    exports: [MyClaimsOverviewContentComponent],
    declarations: [MyClaimsOverviewContentComponent],
})
export class ClaimsOverviewContentModule { }
